/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { getConstants } from '../actions/actionType';

export function Profile(state = {}, action) {
    switch (action.type) {
    case getConstants.PROFILE_SUCCESS:
        return {
            type: getConstants.PROFILE_SUCCESS,
            profile: action.user.data.data,
        };
    case getConstants.PROFILE_FAILURE:
        return {
            type: getConstants.PROFILE_FAILURE,
            message: action.message,
        };
    default:
        return state;
    }
}
